export interface StorageHealth {
  persisted: boolean | undefined;
  quota?: number;
  usage?: number;
  usageRatio?: number;
  lowStorage: boolean;
  persistenceUnavailable: boolean;
}

export async function getStorageHealth(): Promise<StorageHealth> {
  const storageManager = navigator.storage;
  const estimate = storageManager?.estimate ? await storageManager.estimate() : {};
  let persisted: boolean | undefined;
  if (storageManager?.persisted) {
    persisted = await storageManager.persisted();
  }
  if (!persisted && storageManager?.persist) {
    try {
      persisted = await storageManager.persist();
    } catch {
      persisted = false;
    }
  }
  const usage = estimate.usage;
  const quota = estimate.quota;
  const usageRatio = usage && quota ? usage / quota : undefined;
  return {
    persisted,
    usage,
    quota,
    usageRatio,
    lowStorage: typeof usageRatio === "number" && usageRatio > 0.82,
    persistenceUnavailable: persisted === false
  };
}
